import { useQuery } from "react-query"
import { useUser } from "@tm/context-distribution"
import { showCustomRepairTimesDefaults } from ".."
import { DEFAULTS_KEY } from "./keys"

export function useCustomRepairTimesDefaults() {
    const { userSettings } = useUser()

    const QUERY_KEY = [DEFAULTS_KEY, userSettings?.hourlyRates, userSettings?.repairTimeOptions]

    const { data, isLoading } = useQuery([QUERY_KEY], () => showCustomRepairTimesDefaults(), {
        staleTime: 30 * 60 * 1000, // 30 minutes,
        enabled: !!userSettings,
    })
    return { customRepairTimesDefaults: data, defaultVatRatesLoading: isLoading }
}
